export const documentList = [ 
  'ConteoSociodemografico',
  'Conteo_GrupoEdad',
  'Conteo_Rango_Ingreso',
  'Conteo_Sexo',
  'Conteo_Region',
  'ProporcionEmociones',
  'SentimientoProm_EdadIngreso',
  'SentimientoProm_EdadRegion',
  'SentimientoProm_GrupoEdad',
  'SentimientoProm_Rango_Ingreso',
  'SentimientoProm_Region',
  'SentimientoProm_RegionIngreso',
  'SentimientoProm_Semaforo',
  'SentimientoProm_Sexo',
  'SentimientoProm_SexoEdad',
  'SentimientoProm_SexoIngreso',
  'SentimientoProm_SexoRegion', //Se mantuvo en la última actualización
  'SentimientoPromedioDiario',
  'EmocionesPromedioDiario',
  'EmocionesProm_Sexo',
  'EmocionesProm_GrupoEdad',
  'EmocionesProm_Rango_Ingreso',
  'EmocionesProm_Region',
  'EmocionesProm_Semaforo',
  'Elasticidad',
  'Keepa',
  'MapaCompetencia',
  'Precios_Stats', //Se mantuvo en la última actualización
  'TrendGeneral',
  'TrendSemaforo',
  'Trend_EdadIngreso',
  'Trend_EdadRegion',
  'Trend_GrupoEdad', //Se mantuvo en la última actualización
  'Trend_Rango_Ingreso', //Se mantuvo en la última actualización
  'Trend_Region', //Se mantuvo en la última actualización
  'Trend_RegionIngreso',
  'Trend_Sexo',
  'Trend_SexoEdad',
  'Trend_SexoIngreso',
  'Trend_SexoRegion', 
  'Subsecciones'
 ]